<template>
    <app-layout title="View Order">

        <page-header>
            <template #title>View Order</template>

            <template #actions>
                <jet-tertiary-button type="button" @click="showDuplicateModal = true">
                    <img src="/images/icons/shopping-cart_g.svg" width="16" height="16" alt="Duplicate Order">
                </jet-tertiary-button>

                <a
                    v-if="order.status === 2"
                    target="_blank"
                    :href="route('customer_orders.print.invoice', order.access_token)"
                >
                    <jet-tertiary-button type="button">
                        <img src="/images/icons/print.svg" width="16" height="16" alt="Print">
                    </jet-tertiary-button>
                </a>

                <!-- Temporarily disabled — uncomment when feature is ready -->
                <!-- <jet-button
                    type="button"
                    v-if="order.status === 2"
                    :href="route('refunds.create', { token: order.refund_token })"
                >Refund</jet-button> -->

                <jet-button
                    type="button"
                    v-if="allowEdit"
                    :href="route('customer_orders.edit', order.id)"
                >Edit</jet-button>

                <jet-tertiary-button type="button" :href="route('customer_orders.index')">
                    Close
                </jet-tertiary-button>
            </template>
        </page-header>

        <div class="px-8">
            <order-details :order="order" />

            <div class="my-4">
                <h3 class="py-2 text-2xl font-bold">Items</h3>

                <order-items :order="order" />
            </div>

            <div class="lg:w-3/4 text-center my-24">
                <p v-if="order.status === -1" class="text-2xl text-red-700 opacity-50">--- Cancelled ---</p>
            </div>
        </div>

        <jet-dialog-modal :show="showDuplicateModal" @close="showDuplicateModal=false">
            <template #title>
                Add Items to Cart
            </template>

            <template #content>
                Would like to add the items on this order to your cart?
            </template>

            <template #footer>
                <jet-button @click="handleDuplicate">
                    Yes
                </jet-button>

                <jet-tertiary-button class="ml-2" @click="showDuplicateModal=false">
                    No
                </jet-tertiary-button>
            </template>
        </jet-dialog-modal>

        <jet-confirmation-modal :show="showCancelModal" @close="showCancelModal=false">
            <template #title>
                Cancel Order
            </template>

            <template #content>
                Are you sure you would like to cancel this order?
            </template>

            <template #footer>
                <jet-danger-button @click="handleCancel">
                    Yes
                </jet-danger-button>

                <jet-tertiary-button class="ml-2" @click="showCancelModal=false">
                    No
                </jet-tertiary-button>
            </template>
        </jet-confirmation-modal>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue';
import PageHeader from '@/Layouts/partials/PageHeader.vue';
import JetButton from '@/Jetstream/Button';
import JetDialogModal from '@/Jetstream/DialogModal';
import JetConfirmationModal from '@/Jetstream/ConfirmationModal';
import JetDangerButton from '@/Jetstream/DangerButton';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';
import OrderDetails from '@/Shared/Orders/OrderDetails';
import OrderItems from '@/Shared/Orders/OrderItems';
import { DateTime } from "luxon";

export default {

    components: {
        AppLayout,
        PageHeader,
        JetButton,
        JetConfirmationModal,
        JetDangerButton,
        JetDialogModal,
        JetTertiaryButton,
        OrderDetails,
        OrderItems,
    },

    props: ['order'],

    data() {
        return {
            showCancelModal: false,
            showDuplicateModal: false,
        }
    },

    computed: {
        activeCustomer() {
            return this.$page.props.activeCustomer;
        },

        allowEdit() {
            return this.order.status == 0 && this.order.ship_date !== this.order.order_date && this.order.ship_date > DateTime.now().toFormat('yyyy-LL-dd');
        }
    },

    methods: {
        handleDuplicate() {
            this.$inertia.get(route('customer_orders.duplicate', this.order.id));
        },

        handleCancel() {
            this.$inertia.delete(route('customer_orders.destroy', this.order.id));
        },
    },
}
</script>

<style scoped>

</style>
